<template>
  <div>
    <div class="panel animated fadeInRightBig">
      <div class="panel-heading">
        <div class="panel-title">
          <div class="row">
            <form>
              <div class="form-group col-md-4">
                <label for="id">ID</label>
                <input
                  class="form-control"
                  v-model="event.id"
                  name="id"
                  id="id"
                  readonly
                />
              </div>
              <div class="form-group col-md-4">
                <label for="user_created">Criado por</label>
                <input
                  class="form-control"
                  v-model="event.user_created.name"
                  name="user_created"
                  id="user_created"
                  readonly
                />
              </div>
              <div class="form-group col-md-4">
                <label for="created_at">Criado em</label>
                <input
                  class="form-control"
                  v-model="created_at"
                  name="created_at"
                  id="created_at"
                  readonly
                />
              </div>
              <div class="form-group col-md-4">
                <label for="user_started">Iniciado por</label>
                <input
                  class="form-control"
                  v-model="event.user_started.name"
                  name="user_started"
                  id="user_started"
                  readonly
                />
              </div>
              <div class="form-group col-md-4">
                <label for="started_at">Iniciado em</label>
                <input
                  class="form-control"
                  v-model="started_at"
                  name="started_at"
                  id="started_at"
                  readonly
                />
              </div>
              <div class="form-group col-md-4">
                <label for="user_closed">Encerrado por</label>
                <input
                  class="form-control"
                  v-model="event.user_closed.name"
                  name="user_closed"
                  id="user_closed"
                  readonly
                />
              </div>
              <div class="form-group col-md-4">
                <label for="closed_at">Encerrado em</label>
                <input
                  class="form-control"
                  v-model="closed_at"
                  name="closed_at"
                  id="closed_at"
                  readonly
                />
              </div>
              <div class="form-group col-md-4">
                <label for="dds_date">Data de Execução</label>
                <input
                  class="form-control"
                  v-model="dds_date"
                  name="dds_date"
                  id="dds_date"
                  readonly
                />
              </div>
              <div class="form-group col-md-4">
                <label for="theme_id">Tema</label>
                <input
                  class="form-control"
                  v-model="event.theme.title"
                  name="theme"
                  id="theme"
                  readonly
                />
              </div>
              <div class="form-group col-md-4">
                <label for="team">Área</label>
                <input
                  class="form-control"
                  v-model="event.teams_shifts.team.name"
                  name="team"
                  id="team"
                  readonly
                />
              </div>
              <div class="form-group col-md-4">
                <label for="shift">Turno</label>
                <input
                  class="form-control"
                  v-model="event.teams_shifts.shift.name"
                  name="shift"
                  id="shift"
                  readonly
                />
              </div>
              <div class="form-group col-md-4">
                <label for="participants">Total de Participantes</label>
                <input
                  class="form-control"
                  v-model="event.participants"
                  name="participants"
                  id="participants"
                  readonly
                />
              </div>
              <div class="form-group col-md-4">
                <label for="participants_external">Total de Terceiros</label>
                <input
                  class="form-control"
                  v-model="event.participants_external"
                  name="participants_external"
                  id="participants_external"
                  readonly
                />
              </div>
              <div class="form-group col-md-4">
                <label for="special">Tema Especial</label>
                <input
                  class="form-control"
                  v-model="special"
                  name="special"
                  id="special"
                  readonly
                />
              </div>
              <!-- <div class="form-group col-md-4">
                <label for="quantity_person">Quantidade Esperada de Total de Participantes</label>
                <input class="form-control" v-model="event.quantity_person" name="quantity_person" id="quantity_person" readonly>
              </div>-->
              <div class="form-group col-md-4">
                <label for="status">Status</label>
                <input
                  class="form-control"
                  v-model="event.status.name"
                  name="status"
                  id="status"
                  readonly
                />
              </div>
              <!--<div class="form-group col-md-4">
                <label for="lecturer">Executante</label>
                <input
                  class="form-control"
                  v-model="event.user_started.name"
                  name="lecturer"
                  id="lecturer"
                  readonly
                />
              </div>-->
              <div class="form-group col-md-8">
                <label for="obs">Observação</label>
                <textarea
                  rows="4"
                  cols="50"
                  class="form-control"
                  v-model="event.obs"
                  name="obs"
                  id="obs"
                  readonly
                />
              </div>
            </form>
          </div>
          <div>
            <h1>Total de Participantes</h1>

            <div class="row" style="margin-top: 30px; text-align: center">
              <div class="col-md-12">
                <vue-ellipse-progress
                  :progress="getPercent"
                  :size="200"
                  thickness="15"
                  :fontSize="'25px'"
                  :legendValue="totalConfirmed"
                >
                  <span slot="legend-value"
                    >/{{ event.signatures.length }}</span
                  >
                  <p slot="legend-caption">Participantes</p>
                </vue-ellipse-progress>
              </div>
            </div>
            <br />
            <table class="table table-stripped">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>E-mail</th>
                  <th>Status</th>
                  <th>Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="participant in event.signatures"
                  :key="participant.id"
                >
                  <td>{{ participant.user.name }}</td>
                  <td>{{ participant.user.email }}</td>
                  <td>
                    {{
                      participant.status == 0 ? "Ausente" : "Presente"
                    }}
                  </td>
                  <td style="width: 2%">
                    <button
                      v-if="participant.status == 1"
                      class="btn btn-info fa fa-eye"
                      @click="modalImage(participant.signature_image)"
                    ></button>
                    <button
                      v-if="participant.status == 1"
                      class="btn btn-warning fa fa-map"
                      @click="det(participant)"
                    ></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <router-link to="/events" class="btn btn-info" style="float: right">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
        </div>
      </div>
      <div class="panel-body">
        <div></div>
      </div>
    </div>
    <!-- Modal Assinatura-->
    <div
      class="modal fade"
      id="signModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="signModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="signModalLabel">
              Captura da Assinatura
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <img :src="this.image_signature" width="100%" />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Detalhe Assinatura -->

    <div
      class="modal fade"
      id="modalDetail"
      tabindex="-1"
      role="dialog"
      aria-labelledby="signModalLabel"
      aria-hidden="true"
      v-if="detail"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="signModalLabel">
              Detalhes da Assinatura
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row content-detail">
              <div class="col-md-6" style="font-size: 16px">
                <i class="fa fa-user"></i>
                &nbsp;Assinado por {{ detail.user.name }}
              </div>

              <div class="col-md-6" style="font-size: 16px">
                <i class="fa fa-calendar"></i>
                &nbsp;Assinado em {{ detail.updated_at }}
              </div>
            </div>
            <div class="row content-detail">
              <div class="col-md-6" style="font-size: 16px">
                <i class="fa fa-globe"></i>
                &nbsp;Assinado no IP {{ detail.ip }}
                <br />
                <br />
              </div>
            </div>
            <div class="row content-detail">
              <div class="col-md-12" style="font-size: 16px">
                <i class="fa fa-map"></i>
                &nbsp;Geolocalização (Latitude: {{ detail.latitude }} |
                Longitude: {{ detail.longitude }})
                <br />
                <br />
              </div>
            </div>
            <div class="row content-detail">
              <div class="col-md-12">
                <iframe
                  width="100%"
                  height="250"
                  frameborder="0"
                  style="border: 0"
                  :src="src"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      image_signature: "",
      event: {
        id: "",
        started_at: "",
        closed_at: "",
        dds_date: "",
        created_at: "",
        updated_at: "",
        team_id: "",
        participants: "",
        participants_external: "",
        shift_id: "",
        theme_id: "",
        deleted_at: "",
        type: "",
        quantity_person: "",
        status_id: "",
        lecturer: "",
        registry: "",
        obs: "",
        user_created: {
          name: "",
          registry: "",
        },
        user_started: "",
        user_closed: "",
        theme: {
          title: "",
        },
        status: {
          name: "",
        },
        teams_shifts: {
          team: {},
          shift: {},
        },
      },
      errors: undefined,
      detail: "",
      totalConfirmed: 0,
    };
  },
  computed: {
    dds_date: function () {
      return this.formattedDate(this.event.dds_date);
    },
    started_at: function () {
      return this.formattedDate(this.event.started_at);
    },
    closed_at: function () {
      return this.formattedDate(this.event.closed_at);
    },
    created_at: function () {
      return this.formattedDate(this.event.created_at);
    },
    lecturer: function () {
      if (!this.event.lecturer) {
        return "";
      }
      return this.event.lecturer + " (" + this.event.registry + ")";
    },
    special: function () {
      return this.event.theme.special ? "Sim" : "Não";
    },
    getPercent: function () {
      var totalParticipants = this.event.signatures.length;
      var confirmed = this.totalConfirmed;

      var ret = (confirmed * 100 * 100) / totalParticipants / 100;
      return ret;
    },
  },
  methods: {
    det(det) {
      this.detail = det;
      console.log(det);
      this.src =
        "https://www.google.com/maps/embed/v1/place?key=AIzaSyAVReyDOd0JcVSHy1CvERGbMXbqA1pkiZA&q=" +
        this.detail.latitude +
        "," +
        this.detail.longitude +
        "&zoom=18&maptype=roadmap";

      console.log(this.src);
      $("#modalDetail").modal({
        show: true,
      });
    },
    formattedDate: function (d) {
      if (!d) {
        return "";
      }
      d = new Date(d).toLocaleString();
      d = d.slice(0, -3);
      return d;
    },
    modalImage(img) {
      this.image_signature = img;
      $("#signModal").modal({
        show: true,
      });
    },
    getEvent: function () {
      let self = this;
      let id = self.$route.params.id;
      let api =
        self.$store.state.api +
        "events/" +
        id +
        "?with[]=user_created&with[]=user_started&with[]=user_closed&with[]=teams_shifts.team&with[]=theme&with[]=status&with[]=teams_shifts.shift&with[]=signatures";

      self.$http
        .get(api)
        .then((response) => {
          self.event = response.data.data[0];
          var confirmed = 0;
          var ret = this.event.signatures.forEach((element) => {
            if (element.status > 0) {
              confirmed = Number(confirmed) + 1;
            }
          });
          this.totalConfirmed = confirmed;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted: function () {
    this.getEvent();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Event/View.vue